import type { Directive } from "vue";

const vFocus: Directive = {
  created: (el, binding) => {
    // when the directive has a value, that is not true, disable it
    if (!(binding.value === undefined || binding.value === true)) {
      binding.dir.mounted = () => {};
    }
  },

  mounted: (el) => {
    el.focus();
  },
};

export default vFocus;
